import { defineComponent as l, computed as u, createBlock as p, openBlock as m, unref as o, normalizeClass as c, withCtx as r, createVNode as n } from "vue";
import { NodeViewWrapper as f, NodeViewContent as g } from "@tiptap/vue-3";
import v from "../../../EditorHandle.vue.js";
import b from "./ScalarHeading.vue.js";
import { useAttrModel as h } from "../../../../hooks/useAttrModel.js";
import { useIsEditable as _ } from "../../../../hooks/useIsEditable.js";
const C = "heading-1", F = /* @__PURE__ */ l({
  __name: "CustomHeading",
  props: {
    decorations: {},
    selected: { type: Boolean },
    updateAttributes: { type: Function },
    deleteNode: { type: Function },
    node: {},
    view: {},
    getPos: { type: Function },
    innerDecorations: {},
    editor: {},
    extension: {},
    HTMLAttributes: {}
  },
  setup(s) {
    const t = s, i = u(() => t.node.attrs.level === 1 ? "0.4em" : t.node.attrs.level === 2 ? "0.1em" : "0"), { isEditable: d } = _(t.editor), a = h(t, "slug");
    return (e, w) => (m(), p(o(f), {
      class: c(["guide-node-component", { [C]: e.node.attrs.level === 1 }])
    }, {
      default: r(() => [
        n(v, {
          editor: e.editor,
          getPos: e.getPos,
          node: e.node,
          shift: i.value
        }, null, 8, ["editor", "getPos", "node", "shift"]),
        n(b, {
          id: o(a),
          "data-level": e.node.attrs.level,
          isEditable: o(d),
          level: e.node.attrs.level
        }, {
          default: r(() => [
            n(o(g), { as: "span" })
          ]),
          _: 1
        }, 8, ["id", "data-level", "isEditable", "level"])
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
export {
  F as default
};
